import { render } from "./PhotoUpload.vue?vue&type=template&id=a41045e6&scoped=true&ts=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=ts"
export * from "./PhotoUpload.vue?vue&type=script&lang=ts"

import "./PhotoUpload.vue?vue&type=style&index=0&id=a41045e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41045e6"]])

export default __exports__